import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/Timeline';
import create from './create';
import edit from './edit';
import list from './list';

const timelineItems: ResourceProps = {
  name: 'timeline-items',
  icon,
  options: { label: 'Linha do tempo' },
  create,
  edit,
  list
};

export default timelineItems;
